import React from 'react';
import './ProgressLoadingBar.css';

export type ProgressLoadingBarProps = {
  progress?: number;
};

const ProgressLoadingBar: React.FC<ProgressLoadingBarProps> = ({ progress }) => {
  return (
    <div className="loading">
      {progress === undefined || progress === null ? (
        <div className="spinner-container">
          <div className="rotating-arrow"></div>
        </div>
      ) : (
        <div
          className="progress-bar"
          style={{ width: `${progress}%` }}
        ></div>
      )}
    </div>
  );
};

export default ProgressLoadingBar;
